import CandidatesIcon from 'assets/images/iPrise/Candidates.svg';
import JobQueueIcon from 'assets/images/iPrise/JobQueue.svg';
import TeamIcon from 'assets/images/iPrise/Team.svg';
import CommonHeader, { NavItem } from 'pages/iPriseV2/common/layout/Header';
import React from 'react';

const TeamLeadHeader: React.FC = () => {
  const navItems: NavItem[] = [
    { icon: JobQueueIcon, label: 'Job Queue', path: '/team-lead/job-queue' },
    {
      icon: CandidatesIcon,
      label: 'Candidates',
      path: '/team-lead/candidates',
    },
    { icon: TeamIcon, label: 'My Team', path: '/team-lead/teams' },
  ];

  return (
    <CommonHeader
      navItems={navItems}
      profilePath="/team-lead/profile"
      basePath="/team-lead"
    />
  );
};

export default TeamLeadHeader;
